export interface ISampleStatusData {
    id: string;
    name: string;
}


export default class SampleStatusData implements ISampleStatusData {
    id: string;
    name: string;

    constructor(
        id: string,
        name: string
    ) {
        this.id = id;
        this.name = name;
    }
}

const defaultSampleStatusData = new SampleStatusData(
    "",
    ""
);
export { defaultSampleStatusData };
